module.exports = __webpack_public_path__ + "img/FPTemp4.1c02bc57.png";